import { MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { Col } from "react-grid-system";
import { useTranslation } from "react-i18next";

const Error = () => {
    const { t } = useTranslation();
  
    return (
        <Col>
            <MessageBar intent='error'>
                <MessageBarBody>
                    <MessageBarTitle>
                        {t("general.error")}
                    </MessageBarTitle>
                    {t("folders.errors.loadFolders")}
                </MessageBarBody>
            </MessageBar>
        </Col>
    );
};

export default Error;